import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileText } from "lucide-react";
import { exportToCSV, exportToExcel } from "../../utils/exportData";
import { ContestRegistration } from "./hooks/useContestData";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

interface ExportButtonsProps {
  registrations: ContestRegistration[];
}

const formatForExport = (registrations: ContestRegistration[]) => {
  return registrations.map((reg) => ({
    "Date d'inscription": format(new Date(reg.created_at), "dd/MM/yyyy HH:mm", { locale: fr }),
    "Catégorie": reg.category === "college" ? "Collège" : "Lycée",
    "Nom de la classe": reg.class_name || "",
    "Niveau": reg.class_level,
    "Nombre de participants": reg.participants_count,
    "Effectif total": reg.total_students_count,
    "Académie": reg.academy,
    "Établissement": reg.school_name,
    "Adresse établissement": reg.school_address,
    "Code postal": reg.school_postal_code,
    "Ville": reg.school_city,
    "Téléphone établissement": reg.school_phone,
    "Email établissement": reg.school_email,
    "Chef d'établissement": reg.principal_name,
    "Nom enseignant": reg.teacher_name,
    "Fonction": reg.teacher_function,
    "Téléphone enseignant": reg.teacher_phone,
    "Email enseignant": reg.teacher_email,
  }));
};

export const ExportButtons = ({ registrations }: ExportButtonsProps) => {
  const handleExportCSV = () => {
    const data = formatForExport(registrations);
    exportToCSV(data, `inscriptions-concours-${format(new Date(), "yyyy-MM-dd")}`);
  };

  const handleExportExcel = () => {
    const data = formatForExport(registrations);
    exportToExcel(data, `inscriptions-concours-${format(new Date(), "yyyy-MM-dd")}`);
  };

  return (
    <div className="flex gap-2">
      <Button variant="outline" size="sm" onClick={handleExportCSV}>
        <FileText className="h-4 w-4 mr-2" />
        CSV
      </Button>
      <Button variant="outline" size="sm" onClick={handleExportExcel}>
        <FileSpreadsheet className="h-4 w-4 mr-2" />
        Excel
      </Button>
    </div>
  );
};
